export const ISSUES_FOR_CNC_REQUEST = "ISSUES_FOR_CNC_REQUEST";
export const ISSUES_FOR_CNC_SUCCESS = "ISSUES_FOR_CNC_SUCCESS";
export const ISSUES_FOR_CNC_FAILED = "ISSUES_FOR_CNC_FAILED";